
namespace RioERP.Products {
    export class ProductFranchiseeShareColumns {
        static columnsKey = 'Products.ProductFranchiseeShare';
    }
}